import ChangeStatusConfirmModal from './ChangeStatusConfirmModal';

export default ChangeStatusConfirmModal;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/scoring/change-status-modal/index.js